module.exports = __webpack_public_path__ + "img/menu-casino.c02695e7.png";